import { PageLayout } from '@/layouts/page-layout'
import { useTranslation } from 'react-i18next'
import { Await, Link, useLoaderData, useSearchParams } from 'react-router-dom'
import { CreateButton } from '@/shared/components/action-buttons'
import { Button, Input } from '@material-tailwind/react'
import { FiDisc, FiSearch, FiUsers } from 'react-icons/fi'
import { create, list } from '@/router/utils'
import { HasAccess } from '@permify/react-role'
import { HasSetting } from '@/components/has-setting'
import { useAuthorization } from '@/hooks'
import { Suspense, useEffect } from 'react'
import { UserTable } from './tables'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'
import { FilterPopover } from '@/shared/components/filter-popover'
import { CompanySelector, UserRoleSelector } from '@/shared/selectors'

export const UserList = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })

  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  const { promise } = useLoaderData()
  const companyId = searchParams.get('company_id')
  const roleId = searchParams.get('role_id')

  const handleFilter = ({ key, value } = {}) => {
    searchParams.set('page', 1)
    if (!value) {
      searchParams.delete(key)
      setSearchParams(searchParams)
      return
    }

    searchParams.set(key, value)
    setSearchParams(searchParams)
  }

  useEffect(() => {
    hasAccess('user#list')
  }, [])

  return (
    <PageLayout
      title={t('user.other')}
      actions={[
        <div key='actions' className='w-full flex gap-3'>
          <Input
            name="q"
            icon={<FiSearch />}
            className='w-full sm:w-80'
            label="Buscar por nombre, apellido o email"
            onChange={(event) => handleFilter({ key: 'q', value: event.target.value })}
            value={searchParams.get('q')}
          />
          <FilterPopover>
            <div className='grid gap-4'>
              <CompanySelector
                onChange={(option = {}) => handleFilter({ key: 'company_id', value: option?.value })}
                value={companyId ? Number(companyId) : null}
              />
              <UserRoleSelector
                onChange={(option = {}) => handleFilter({ key: 'role_id', value: option?.value })}
                value={roleId ? Number(roleId) : null}
              />
            </div>
          </FilterPopover>
          <HasAccess permissions='permission#update'>
            <Link to={list('users/groups')}>
              <Button className='flex justify-center items-center gap-2 text-nowrap' variant='outlined' color='white'>
                <FiUsers size='1rem' />
                Gestionar grupos
              </Button>
            </Link>
          </HasAccess>
          <HasSetting setting="privileged_user" fallback={null}>
            <Link to={list('user_roles')}>
              <Button className='flex justify-center items-center gap-2 text-nowrap' variant='outlined' color='white'>
                <FiDisc size='1rem' />
                Gestionar perfiles
              </Button>
            </Link>
          </HasSetting>

          <HasAccess permissions='user#create'>
            <Link to={create('users')}>
              <CreateButton />
            </Link>
          </HasAccess>
        </div >
      ]}
    >
      <Suspense fallback={<PageLayoutOverlay />}>
        <Await resolve={promise} errorElement={<PageLayoutError />}>
          {(data) => <UserTable data={data} />}
        </Await>
      </Suspense>

    </PageLayout >
  )
}
